import Axios from "axios";
import config from "../app.config";

export var userSetting;
export default userSetting = {
  saveUserSetting,
  getUserSetting,
}

async function saveUserSetting(data) {
  return await Axios.post(`${config.LOCAL_API_URL}/user-setting`, data)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}

async function getUserSetting(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/user-setting/${data}`)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}